import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const subs = [
  { title: 'subvention_1_title', desc: 'subvention_1_desc', icon: 'ri-leaf-line' },
  { title: 'subvention_2_title', desc: 'subvention_2_desc', icon: 'ri-home-smile-line' },
  { title: 'subvention_3_title', desc: 'subvention_3_desc', icon: 'ri-calculator-line' },
  { title: 'subvention_4_title', desc: 'subvention_4_desc', icon: 'ri-bank-line' },
];

export default function Subventions() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="subventions" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('subventions_h2')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {subs.map((s, idx) => (
          <div
            key={idx}
            className={`bg-white border border-soft-gray rounded-xl p-5 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 100 + 150}ms` }}
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-copper/10 mb-3">
              <i className={`${s.icon} text-copper`} />
            </div>
            <h4 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">{t(s.title)}</h4>
            <p className="text-slate-primary/60 text-sm leading-relaxed">{t(s.desc)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}